/* eslint-disable import/prefer-default-export */
import DeckGL from './components/DeckGL.react';

export {
    DeckGL
};
